import healthcareExpenseResource from "@/shared/resource/healthcareExpense";
import { authorizedAxios } from "./authorizedAxios";
import { HealthcareExpenseForecastRequest } from "@/shared/types";

export function getConditions () {
  return authorizedAxios.get(healthcareExpenseResource.getConditions());
}

export function getForecastRequest () {
  return authorizedAxios.get(healthcareExpenseResource.getForecastRequest());
}

export function getHsaForecast () {
  return authorizedAxios.get(healthcareExpenseResource.getHsaForecast());
}

export function updateHsaForecast (request: HealthcareExpenseForecastRequest) {
  return authorizedAxios.post(healthcareExpenseResource.updateHsaForecast(), request);
}